import {createSlice, Dispatch, PayloadAction} from '@reduxjs/toolkit';

const initialState: any = Number;

const caseGeneratorCurrentStepSlice = createSlice({
    name: 'caseGeneratorCurrentStep',
    initialState,
    reducers: {
    setCurrentState(state, action: PayloadAction<any | null>): void {
            return action.payload;
        },
    }
});

export const setCurrentStateAction = (currentStep : Number) => (dispatch: Dispatch) => {
    dispatch(setCurrentState(currentStep));
  };
  
export const {
    setCurrentState
} = caseGeneratorCurrentStepSlice.actions;

export default caseGeneratorCurrentStepSlice.reducer;